/**
 * Attendance entity - domain model utilities
 * Pure derivations from attendance data (no UI dependencies)
 */

export interface AttendanceMemberStats {
  status: string;
  clockInAt: string | null;
  isLate: boolean;
}

export interface AttendanceSummary {
  presentCount: number;
  lateCount: number;
  absentCount: number;
}

/**
 * Derive attendance summary counts from a list of members.
 *
 * - present: CLOCKED_IN or ON_BREAK
 * - late: isLate flag
 * - absent: CLOCKED_OUT without any clockIn record
 */
export function getAttendanceSummary(members: AttendanceMemberStats[]): AttendanceSummary {
  let presentCount = 0;
  let lateCount = 0;
  let absentCount = 0;

  for (const m of members) {
    if (m.status === 'CLOCKED_IN' || m.status === 'ON_BREAK') presentCount++;
    if (m.isLate) lateCount++;
    if (m.status === 'CLOCKED_OUT' && !m.clockInAt) absentCount++;
  }

  return { presentCount, lateCount, absentCount };
}
